/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_RegisterInputs */

const es_landing_cta_register = /** @type {(inputs: Landing_Cta_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra tu barco`)
};

const gl_landing_cta_register = /** @type {(inputs: Landing_Cta_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rexistra o teu barco`)
};

const en_landing_cta_register = /** @type {(inputs: Landing_Cta_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List your boat`)
};

/**
* | output |
* | --- |
* | "List your boat" |
*
* @param {Landing_Cta_RegisterInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_cta_register = /** @type {((inputs?: Landing_Cta_RegisterInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_RegisterInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_cta_register(inputs)
	if (locale === "en") return en_landing_cta_register(inputs)
	return es_landing_cta_register(inputs)
});